<script setup lang="ts"></script>

<template>
  <svg
    id="svg2"
    xmlns:dc="http://purl.org/dc/elements/1.1/"
    xmlns:cc="http://creativecommons.org/ns#"
    xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"
    xmlns:svg="http://www.w3.org/2000/svg"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 122.61333 105.64"
    height="105.64"
    width="122.61333"
    xml:space="preserve"
    version="1.1"
  >
    <metadata id="metadata8">
      <rdf:RDF
        ><cc:Work rdf:about=""
          ><dc:format>image/svg+xml</dc:format
          ><dc:type rdf:resource="http://purl.org/dc/dcmitype/StillImage" /></cc:Work
      ></rdf:RDF>
    </metadata>
    <defs id="defs6" />
    <g id="g10" transform="matrix(1.3333333,0,0,-1.3333333,0,105.64)">
      <g id="g12" transform="scale(0.1)">
        <path
          id="path14"
          style="fill: #ffffff; fill-opacity: 1; fill-rule: nonzero; stroke: none"
          d="m 712.227,563.168 c 43.164,-59.492 27.507,-143.957 -31.563,-219.27 l 92.723,-37.648 c 8.379,10.246 16.308,20.617 23.644,31.066 l -61.953,26.172 c 14.891,22.723 26.531,45.887 34.317,68.914 24.191,75.977 5.75,142.926 -45.911,185.336 l -9.441,-5.605 c -9.551,8.066 -20.5,15.203 -33.066,21.222 -28.555,13.7 -62.032,20.317 -97.852,20.708 l -11.191,-21.922 -2.098,-4.114 c 0.086,-0.035 0.152,-0.023 0.281,0 60.938,-2.89 112.676,-24.363 142.11,-64.859"
        />
        <path
          id="path16"
          style="fill: #ffffff; fill-opacity: 1; fill-rule: nonzero; stroke: none"
          d="m 869.402,657.809 c 3.293,-4.84 6.407,-9.782 9.297,-14.704 l 40.938,24.606 c -2.926,4.93 -6.043,9.875 -9.356,14.691 -20.566,29.739 -47.703,53.911 -79.765,72.797 l -8.512,-8.418 c -5.434,3.199 -10.981,6.285 -16.859,9.149 -46.747,23.644 -101.903,35.379 -161.239,36.41 l -11.074,-23.945 c 102.469,-4.582 188.848,-41.508 236.57,-110.586"
        />
        <path
          id="path18"
          style="fill: #ffffff; fill-opacity: 1; fill-rule: nonzero; stroke: none"
          d="m 909.285,376.906 c -5.945,1.192 -36.961,14.817 -69.539,26.117 39.149,84.985 39.863,170.375 -7.305,235.36 -7.656,10.504 -16.328,20.051 -25.859,28.816 l -10.488,-6.25 c -14.699,14.336 -32.305,26.864 -53.281,36.992 -37.786,18.157 -82.059,26.864 -129.426,27.09 l -11.563,-25.894 c 81.66,-2.789 151.074,-31.098 190.305,-85.063 29.355,-40.504 37.801,-89.945 28.191,-141.883 -3.277,-18.578 -16.98,-56.367 -17.117,-56.289 -5.324,-12.757 -11.785,-25.453 -18.992,-38.078 l 63.629,-27.883 c -17.957,-28.679 -39.668,-57.019 -65.039,-84.207 l -123.836,49.227 c -6.543,-6.805 -13.504,-13.445 -20.774,-19.949 l -12.031,3.789 C 592.91,272.277 554.766,250.43 515,234.797 l -1.211,-14.59 c 0,0 -63.234,-22.715 -94.922,-23.918 l 1.043,14.231 c -18.691,-2.168 -37.187,-2.715 -55.144,-1.485 -10.664,-17.648 -60,-99.98 -60,-99.98 57.675,-3.028 133.886,4.492 217.871,38.808 l 1.836,-26.543 C 466.211,99.0156 388.008,76.4766 287.059,81.75 L 238.262,1.35938 C 433.242,-12.918 664.285,86.6133 809.656,240.488 l -0.078,0.032 c 40.481,41.894 74.543,87.753 99.707,136.386"
        />
        <path
          id="path20"
          style="fill: #ffffff; fill-opacity: 1; fill-rule: nonzero; stroke: none"
          d="m 201.641,518.469 h 170.801 v 24.1406 H 201.641 Z"
        />
        <path
          id="path22"
          style="fill: #ffffff; fill-opacity: 1; fill-rule: nonzero; stroke: none"
          d="m 201.914,371.699 h 170.781 v 24.1406 H 201.914 Z"
        />
        <path
          id="path24"
          style="fill: #ffffff; fill-opacity: 1; fill-rule: nonzero; stroke: none"
          d="M 372.598,519.113 356.309,536.934 201.66,395.617 217.949,377.805 372.598,519.113"
        />
        <path
          id="path26"
          style="fill: #ffffff; fill-opacity: 1; fill-rule: nonzero; stroke: none"
          d="M 548.164,473.391 H 425.879 v 44.941 H 548.164 Z M 401.68,542.598 401.641,371.535 h 24.589 l -0.117,77.656 146.25,0.067 0.02,93.254 -170.703,0.086"
        />
        <path
          id="path28"
          style="fill: #ffffff; fill-opacity: 1; fill-rule: nonzero; stroke: none"
          d="m 43.2813,395.469 v 146.855 h -0.3125 v 0.84 H 0 V 519.043 H 19.082 L 19.0234,371.27 H 174.863 v 24.179 l -131.5817,0.02"
        />
      </g>
    </g>
  </svg>
</template>

<style scoped></style>
